import React from 'react';

import LazySymbol from '../../common/lazy';

const Symbol0986 = React.lazy(() => import('./symbols/0986_t-shirt'));
const Symbol0987 = React.lazy(() => import('./symbols/0987_shirt_tie'));
const Symbol0988 = React.lazy(() => import('./symbols/0988_long_sleeves_shirt'));
const Symbol0989 = React.lazy(() => import('./symbols/0989_long_sleeves_shirt'));
const Symbol0990 = React.lazy(() => import('./symbols/0990_short_pants_shorts_bermudas'));
const Symbol0991 = React.lazy(() => import('./symbols/0991_pants'));
const Symbol0992 = React.lazy(() => import('./symbols/0992_skirt'));
const Symbol0993 = React.lazy(() => import('./symbols/0993_dress'));
const Symbol0994 = React.lazy(() => import('./symbols/0994_underwear'));
const Symbol0995 = React.lazy(() => import('./symbols/0995_socks'));
const Symbol0996 = React.lazy(() => import('./symbols/0996_baseball_cap'));
const Symbol0997 = React.lazy(() => import('./symbols/0997_cap_hat_beanie'));
const Symbol0998 = React.lazy(() => import('./symbols/0998_women_high_heels_shoe'));
const Symbol0999 = React.lazy(() => import('./symbols/0999_sneakers_freetime_shoe'));
const Symbol1000 = React.lazy(() => import('./symbols/1000_boots_high_shoe'));
const Symbol1001 = React.lazy(() => import('./symbols/1001_no_ironing'));
const Symbol1002 = React.lazy(() => import('./symbols/1002_steam_ironing'));
const Symbol1003 = React.lazy(() => import('./symbols/1003_steam_ironing'));
const Symbol1004 = React.lazy(() => import('./symbols/1004_no_dryer'));
const Symbol1005 = React.lazy(() => import('./symbols/1005_washing_machine'));

export interface IProps {}

const Clothing: React.FC<IProps> = React.memo(() => {
  return (
    <>
      <LazySymbol id="0986_t-shirt" symbol={<Symbol0986 />} />
      <LazySymbol id="0987_shirt_tie" symbol={<Symbol0987 />} />
      <LazySymbol id="0988_long_sleeves_shirt" symbol={<Symbol0988 />} />
      <LazySymbol id="0989_long_sleeves_shirt" symbol={<Symbol0989 />} />
      <LazySymbol id="0990_short_pants_shorts_bermudas" symbol={<Symbol0990 />} />
      <LazySymbol id="0991_pants" symbol={<Symbol0991 />} />
      <LazySymbol id="0992_skirt" symbol={<Symbol0992 />} />
      <LazySymbol id="0993_dress" symbol={<Symbol0993 />} />
      <LazySymbol id="0994_underwear" symbol={<Symbol0994 />} />
      <LazySymbol id="0995_socks" symbol={<Symbol0995 />} />
      <LazySymbol id="0996_baseball_cap" symbol={<Symbol0996 />} />
      <LazySymbol id="0997_cap_hat_beanie" symbol={<Symbol0997 />} />
      <LazySymbol id="0998_women_high_heels_shoe" symbol={<Symbol0998 />} />
      <LazySymbol id="0999_sneakers_freetime_shoe" symbol={<Symbol0999 />} />
      <LazySymbol id="1000_boots_high_shoe" symbol={<Symbol1000 />} />
      <LazySymbol id="1001_no_ironing" symbol={<Symbol1001 />} />
      <LazySymbol id="1002_steam_ironing" symbol={<Symbol1002 />} />
      <LazySymbol id="1003_steam_ironing" symbol={<Symbol1003 />} />
      <LazySymbol id="1004_no_dryer" symbol={<Symbol1004 />} />
      <LazySymbol id="1005_washing_machine" symbol={<Symbol1005 />} />
    </>
  );
});

Clothing.displayName = 'Clothing';

export default Clothing;
